<div class="ada-llm-artifact-viewer ada-full-height ada-border ada-border-2px">
	<ada-drawer
		contentPadding="0px"
		drawerPadding="0px"
		drawerPosition="left"
		triggerIcon="faLayerGroup"
		triggerIconColor="primary"
		[expandedSize]="300"
		[(isCollapsed)]="isCollapsed"
	>
		<div
			class="ada-container ada-flex-align-center ada-container-nowrap"
			data-container-selector="ada-drawer-header"
		>
			<ada-icon
				color="primary"
				icon="faLayerGroup"
				[style.margin-right]="ui.Spacing.SPACING_SMALL"
			/>

			<strong
				ada-color="foreground"
				ada-font-weight="bold"
				[style.margin-right]="ui.Spacing.SPACING_SMALL"
			>
				Artifacts
			</strong>
			<ada-badge count="{{ artifacts.count() }}" />
		</div>
		<div
			ada-llm-artifact-list
			data-container-selector="ada-drawer-drawerContent"
		></div>
		<div
			ada-llm-artifact-renderer
			class="ada-full-height ada-overflowY-hidden"
			data-container-selector="ada-drawer-mainContent"
		></div>
	</ada-drawer>
</div>
